module.exports = __webpack_public_path__ + "static/media/feefo-award.516fc5e8.svg";